module.exports = __webpack_public_path__ + "img/finances-bg-b9.208f5f4f.png";